import { WelcomeMessageService } from "./welcome.message.service";
import { ModalService } from "../modules/modal/modal.service";
import { WelcomeMessageModalComponent } from "../standalone/modals/welcome.message.modal.component";

export class WelcomeMessageUtil {
    static async autoShowWelcomeMessage() {
        const hasAutoShow = await WelcomeMessageService.hasAutoShowWelcomeMessage();
        if (!hasAutoShow) return;
        const message = await WelcomeMessageService.getWelcomeMessage();
        if (!message) return;
        return ModalService.byClass(WelcomeMessageModalComponent);
    }
}
